import {
  SET_SEARCHING,
  SET_EXPORTING,
  SET_MACHINE_LIST,
  SET_MACHINE_QUERY,
  SET_MACHINE_PAGETOTAL,
  SET_MACHINE_PAGE_NUM,
  SET_MACHINE_PAGE_SIZE,
} from './mutation-types'
import api from '@/api'
import files from 'file-saver'
import {objectTrim, getHeaderName} from '@/utils'
import { checkUserName } from '@/views/User/utils'

const initQuery = () => ({
  pageNum: 1,
  pageSize: 50,
  userId: '',
  userName: '',
})

const state = {
  searching: false,
  exporting: false,
  initQuery: initQuery(),
  machineDetail: {
    list: [],
    listPageTotal: 0,
    query: initQuery(),
  },
}

const mutations = {
  [SET_SEARCHING] (state, payload) {
    state.searching = payload
  },
  [SET_EXPORTING] (state, payload) {
    state.exporting = payload
  },
  [SET_MACHINE_LIST] (state, payload) {
    state.machineDetail.list = payload
  },
  [SET_MACHINE_QUERY] (state, payload) {
    state.machineDetail.query = {
      ...state.machineDetail.query,
      ...payload,
    }
  },
  [SET_MACHINE_PAGETOTAL] (state, payload) {
    state.machineDetail.listPageTotal = payload
  },
  [SET_MACHINE_PAGE_NUM] (state, payload) {
    state.machineDetail.query.pageNum = payload
  },
  [SET_MACHINE_PAGE_SIZE] (state, payload) {
    state.machineDetail.query.pageSize = payload
  },
}

const actions = {
  // 初始化包机明细
  initList ({dispatch}) {
    dispatch('setPageNum', 1)
  },
  // 获取包机明细
  async getList ({commit, state, dispatch}, payload) {
    try {
      let params = {
        ...objectTrim(state.machineDetail.query),
        ...payload,
      }
      if (payload && payload.userId && params.userName) {
        delete params.userName
      }
      commit(SET_SEARCHING, true)
      const {data, code} = await api.packApi.queryPackNode(params)
      checkUserName({
        code,
        data,
        callback: ({userId}) => {
          const { userName, ...other } = params
          dispatch('getList', {
            ...other,
            userId,
          })
        },
      })
      if (data) {
        if (data.items && data.items.length) {
          data.items.map(v => {
            v.platform = v.platform.split(',')
          })
          data.items = data.items.map(v => {
            return {
              ...v,
              isEnded: new Date().getTime() >= v.endTime,
            }
          })
        }
        commit(SET_MACHINE_PAGE_NUM, data.pageNum || 1)
        commit(SET_MACHINE_PAGETOTAL, data.total || 0)
        commit(SET_MACHINE_LIST, data.items || [])
        commit(SET_MACHINE_PAGE_SIZE, data.pageSize || 50)
      }
    } catch (error) {
      commit(SET_MACHINE_PAGETOTAL, 0)
      commit(SET_MACHINE_LIST, [])
    }
    commit(SET_SEARCHING, false)
  },
  // 导出包机明细
  async exportExcel ({commit, dispatch}, payload) {
    let params = {
      ...objectTrim(state.machineDetail.query),
      ...payload,
    }
    if (payload && payload.userId && params.userName) {
      delete params.userName
    }
    commit(SET_EXPORTING, true)
    const res = await api.packApi.exportPackNode(params)
    const {data, headers} = res
    try {
      const fileName = getHeaderName(headers)
      const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      files.saveAs(blob, fileName)
    } catch (e) {
      console.log(e)
      const reader = new FileReader()
      reader.onload = () => {
        const result = JSON.parse(reader.result)
        const { code, data } = result
        checkUserName({
          code,
          data,
          callback: ({userId}) => {
            const { userName, ...other } = params
            dispatch('exportExcel', {
              ...other,
              userId,
            })
          },
        })
      }
      reader.readAsText(res.data)
    }
    commit(SET_EXPORTING, false)
  },
  async editPackMachine ({dispatch}, payload) {
    const {result, code} = await api.packApi.saveOrUpdatePackNode(payload)
    return {result, code}
  },
  async deletePackMachine ({dispatch}, payload) {
    const {result, code} = await api.packApi.deletePackNode(payload)
    return {result, code}
  },
  setQuery ({commit, state}, payload) {
    commit(SET_MACHINE_QUERY, payload)
  },
  setPageSize ({commit, dispatch}, payload) {
    commit(SET_MACHINE_PAGE_SIZE, payload)
    commit(SET_MACHINE_PAGE_NUM, 1)
    // dispatch('getList')
  },
  setPageNum ({commit, dispatch}, payload) {
    commit(SET_MACHINE_PAGE_NUM, payload)
    // dispatch('getList')
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
